import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class LicensePresenter extends EntityPresenter {
  static urn = 'license'

  static navOptions(key = 'license') {
    const routes = {
      models: {
        icon: 'publish',
        pageRoutes: ['license'],
      },
    }
    return routes[key]
  }

  static updateLicense(formData) {
    return fetch('/api/v1/license/update', {
      method: 'POST',
      body: formData,
    }).then(response => {
      if (response.ok) return response.json()
    })
  }
}

bindPresenterMethods(LicensePresenter)
